import { createColumnHelper } from "@tanstack/react-table";
import {
  EditActionButton,
  ViewActionButton,
  PrintActionButton,
} from "../../../../../../components/common/primebmd-ui/EditActionButton";
import { ESRColumns } from "../utils/types";
import { useAuth } from "../../../../../../components/AuthProvider";

export const useCreateESRWIPColumns = () => {
  const currUser = useAuth();
  const hasESRManagementPermission =
    currUser &&
    currUser?.currentUserRole?.permissions.includes("ESR::MANAGEMENT");

  const columnHelper = createColumnHelper<ESRColumns>();

  const esrWIPColumns = [
    columnHelper.accessor("esrNumber", {
      id: "esrNumber",
      header: "JO No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("equipmentNo", {
      id: "equipmentNo",
      header: "Equipment No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("projectLocation", {
      id: "projectLocation",
      header: "Project / Location",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("daysElapsed", {
      id: "daysElapsed",
      header: "Days Elapsed",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(hasESRManagementPermission
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <>
                <EditActionButton route={`complete/${row.original.id}`} />
                <PrintActionButton
                  onClick={() => {
                    const url = `${process.env.REACT_APP_API_URL}esr/pdf/${row.original.id}`;
                    window.open(url, "_blank");
                  }}
                />
              </>
            ),

            enableHiding: false,
          }),
        ]
      : [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <>
                <ViewActionButton route={`view/${row.original.id}`} />
                <PrintActionButton
                  onClick={() => {
                    const url = `${process.env.REACT_APP_API_URL}esr/pdf/${row.original.id}`;
                    window.open(url, "_blank");
                  }}
                />
              </>
            ),

            enableHiding: false,
          }),
        ]),
  ];

  return esrWIPColumns;
};
